export const SEARCH_CATEGORIES = {
  STAFF: 'Staff',
  COMMITTEE: 'Committee',
  DIVISION: 'Division',
}